/** Подпись фразового глагола (2026-10-06): у карточки go out часть речи значения — verb (по
 *  ней выбор и сопоставление), а показываем «phrasal verb». Ключ подписей — тот же текст. */
export const PHRASAL_VERB_POS = 'phrasal verb';

export function cardPos(pos: string | null | undefined, isPhrasalVerb?: boolean): string | null {
  if (!pos) return pos ?? null;
  return isPhrasalVerb && pos.toLowerCase() === 'verb' ? PHRASAL_VERB_POS : pos;
}

/** Слово из нескольких слов с частью речи verb — фразовый глагол (go out в поиске). */
export const isPhrasalFront = (front: string | null | undefined) => !!front && front.trim().includes(' ');
